const AIBLE_AUTH_TOKEN = "aible_auth_token";
const AIBLE_TOKEN_EXPIRES = "aible_token_expires";
const AIBLE_USER_TOKEN_EXPIRES = "aible_user_token_expires";
const AIBLE_IAP_TOKEN = "aible_iap_token";
const AIBLE_IAP_AUDIENCE = "aible_iap_audience";
const REFRESH_CUTOFF_TIME_MS = 3 * 60 * 60 * 1000; // 3H
function pipePolicy(...fns) {
    return (initialItem) => {
        return fns.reduce((acc, fn) => {
            if (acc.result === "ALLOW") {
                return fn(initialItem);
            }
            return acc;
        }, policyAllow);
    };
}
const policyAllow = { result: "ALLOW" };
const policyDenied = (details) => ({ result: "DENY", details });
/** Validate that a value has any value. Catches nulls, undefined, NaN, and various empty objects. */
function possibleErrorValuePolicy(item) {
    if (item) {
        return policyAllow;
    }
    return policyDenied("Item did not have a value to check");
}
function finiteNumberPolicy(item) {
    if (typeof item === "number" && Number.isFinite(item)) {
        return policyAllow;
    }
    return policyDenied("Item is not a finite number");
}
/** Checks that a valid Millis number is passed the current time. */
function tokenIsExpiredPolicy(item) {
    if ((item - Date.now()) / 1000 < 0) {
        return policyDenied("Token has already expired");
    }
    return policyAllow;
}
/** Guard function to validate string values to a millisecond number. */
function transformStringToMillis(item) {
    let castedItem;
    // Are we dealing with a datetime string or a float?
    if (typeof item === "string") {
        const castFloat = Number(item);
        const castDateTime = new Date(item).getTime();
        if (castFloat) {
            castedItem = castFloat;
        }
        else if (castDateTime) {
            castedItem = castDateTime;
        }
    }
    const policy = pipePolicy(possibleErrorValuePolicy, finiteNumberPolicy)(castedItem);
    if (policy.result === "DENY") {
        return policy;
    }
    if (typeof castedItem !== "number") {
        return policyDenied("Item was not able to be casted to a valid Millisecond time object.");
    }
    return castedItem;
}
/** Validates possible TokenExpiration values and if the token has expired. */
export function tokenExpirationPolicy(item) {
    const guardedItem = transformStringToMillis(item);
    if (typeof guardedItem !== 'number') {
        return guardedItem;
    }
    const expirationPolicy = tokenIsExpiredPolicy(guardedItem);
    if (expirationPolicy.result === "DENY") {
        return expirationPolicy;
    }
    return policyAllow;
}
export function tokenNeedsRefresh(item, time_ms = REFRESH_CUTOFF_TIME_MS) {
    const guardedItem = transformStringToMillis(item);
    if (typeof guardedItem !== 'number') {
        console.log(guardedItem);
        return "FAILED";
    }
    const currentTime = Date.now();
    const expirationTime = guardedItem;
    if (expirationTime - currentTime < time_ms) {
        return "REFRESH";
    }
    return "TIME_LEFT";
}
export function userTokenPolicy(item) {
    const possibleErrors = possibleErrorValuePolicy(item);
    if (possibleErrors.result === "DENY") {
        return possibleErrors;
    }
    if (typeof item === 'string') {
        return policyAllow;
    }
    return policyDenied("Token was not an expected type.");
}
